import React from 'react';
import styled from 'styled-components';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

export const Fill = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 5px;
`;

export const RowSpaceBetween = styled(Row)`
  justify-content: space-between;
`;

export const PageTop = styled(Paper)`
  padding: 10px 20px;
`;

export const Page = styled(Paper)`
  flex: 1 1 auto;
  ${({ noPadding }) => !noPadding && 'padding: 10px 20px;'}
  ${({ fullHeight }) => fullHeight && 'height: calc(100vh - var(--app-header-height)); display: flex; flex-direction: column;'}
`;

const FlatCloseButton = styled(Button).attrs({
  title: 'Close',
  color: 'inherit',
  variant: 'outlined',
})`
  position: absolute !important;
  top: 5px;
  right: 0;
  border: none !important;
`;

export const CloseButton = (props) => (
  <FlatCloseButton {...props}>
    <CloseIcon/>
  </FlatCloseButton>
);

export const DetailContainer = styled(Paper).attrs({
  elevation: 2,
})`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 60%;
  overflow-y: auto;
`;

export const GroupsContainer = styled(Paper)`
  flex: 1 1 auto;
  width: 70%;
`;

export const Detail = styled(Box).attrs({
  p: { sm: 2, md: 3 },
})`
  position: relative;
  height: 100%;
`;

export const OutlinedIconButton = styled(IconButton)`
  border-radius: 5px !important;
  ${({ withBorder = true }) => withBorder && 'border: 1px solid rgba(0,0,0,.2) !important;'}
  max-height: 30px !important;
  ${({ active }) => active && 'background-color: rgba(0,0,0,.1); !important;'}
`;